import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";
import { motion } from "framer-motion";
import axios from "axios";
import { getPostDate } from "../../../utils/date";
import * as Icon from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const MainNewsItemOne = () => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const leftVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/posts/main-post/`)
      .then((res) => {
        setPost(res.data);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <motion.div
      variants={leftVariants}
      transition={{ duration: 0.7 }}
      initial="hidden"
      animate="visible"
      className="col-lg-6 col-md-12 col-sm-12 col-xs-12 main-news-wrapper one-banner-news"
    >
      {isLoading === true ? (
        <ContentLoader viewBox="0 0 636 381.5" className="bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
        </ContentLoader>
      ) : (
        <Link to={`/post/${post["slug"]}`}>
          <div
            className="main-news-img position-relative"
            style={{
              backgroundImage: `url(${
                process.env.REACT_APP_API_URL + post["image"]
              })`,
            }}
          >
            <div className="position-absolute">
              <p className="news-title-one">
                <span className="exclusive">
                  {lang === "en"
                    ? post.category.name_en
                    : lang === "ru"
                    ? post["category"].name_ru
                    : post["category"].name_tm}
                </span>{" "}
                {lang === "en"
                  ? post.name_en
                  : lang === "ru"
                  ? post.name_ru
                  : post.name_tm}
              </p>
              <span className="news-date">
                {getPostDate(post["pub_date"])} &nbsp;&nbsp; <Icon.Eye />{" "}
                {post.views}
              </span>
            </div>
          </div>
        </Link>
      )}
    </motion.div>
  );
};

export default MainNewsItemOne;
